export enum TaskStatusEnum {
  Todo = 'Todo',
  Cancel = 'Cancel',
  Done = 'Done',
}
